export const DOMAINS = {
  MIPEXR: process.env.MIX_MIPEXR_URL || '',
  REGIN: process.env.MIX_REGIN_URL || '',
  current: domain => domain ? window.location.host === domain : window.location.host
}
